<div (click)="onSort()" class="group flex items-center gap-2" [ngClass]="field ? 'cursor-pointer' : ''">
  <span>{{ label }}</span>

  @if (field) {
    @if (isNewUI) {
      <div class="h-8 w-5 relative">
        <i
          class="absolute top-0 icon-wl-arrow-drop-up text-6 h-5 flex items-center"
          [ngClass]="field === sortField && sortOrder > 0 ? 'text-primary-600' : 'text-neutral-600'"></i>
        <i
          class="absolute bottom-0 icon-wl-arrow-drop-down text-6 h-5 flex items-center"
          [ngClass]="field === sortField && sortOrder < 0 ? 'text-primary-600' : 'text-neutral-600'"></i>
      </div>
    } @else {
      <i
        [ngClass]="
          field === sortField
            ? sortOrder > 0
              ? 'icon-wl-arrow-alt-down text-blue-600'
              : 'icon-wl-arrow-alt-up text-blue-600'
            : 'icon-wl-arrow-alt-down opacity-0 group-hover:opacity-100'
        "></i>
    }
  }
</div>
